import { render, staticRenderFns } from "./view.vue?vue&type=template&id=36ce5bfa"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ce5bfa')) {
      api.createRecord('36ce5bfa', component.options)
    } else {
      api.reload('36ce5bfa', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=36ce5bfa", function () {
      api.rerender('36ce5bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/packageCSG/view.vue"
export default component.exports